import * as http from 'utils/http';
import moment from 'moment';
import config from 'config';

const defaultAddress = {
  zipcode: '',
  company_name: '',
  address_line: '',
  contact_name: '',
  contact_phone: '',
  city: '',
  country: '',
};

export const getTravelTime = async (from, to) => {
  return await http.post(`${config.API_URL_V2}travel-time/`, {
    addresses: [
      { ...defaultAddress, ...(from || {}) },
      { ...defaultAddress, ...(to || {}) },
    ],
  });
};

export const getPickupDurationByNumberOfItems = (numberOfItems) => {
  if (numberOfItems >= 26) return 120;
  if (numberOfItems >= 21) return 100;
  if (numberOfItems >= 16) return 80;
  if (numberOfItems >= 11) return 60;
  if (numberOfItems >= 6) return 45;
  return 30;
};

export const getStandstillCourtesyTimes = async ({ country, numberOfItems, weight }) => {
  return await http.get(
    `${config.API_URL}standstill/courtesy_times/?country_code=${country}&weight=${weight}&number_of_pallets=${numberOfItems}`
  );
};

export const getDurationFromMinutes = (amount) => {
  const hours = moment
    .utc()
    .startOf('day')
    .add({ minutes: Math.abs(amount) })
    .hours();

  const min = moment
    .utc()
    .startOf('day')
    .add({ minutes: Math.abs(amount) })
    .minutes();

  return `${amount < 0 ? '-' : ''}${hours > 0 ? `${hours}h ` : ''}${min}min`;
};

export const getNumberOfPallets = (loads) => {
  return loads.reduce((acc, { number_of_items }) => {
    if (number_of_items) {
      return acc + Number(number_of_items);
    }
    return acc;
  }, 0);
};

export const getTravelTimeGivenInForm = ({ start, finish }) => {
  const _start = moment(start);
  const _finish = moment(finish);

  return _finish.diff(_start, 'minutes');
};

export const getTravelTimeNeeded = ({ start, timeTravelling, timeInPickup }) => {
  const _start = moment(start);
  const _finish = moment(start).add({ seconds: timeTravelling }).add({ minutes: timeInPickup });

  return _finish.diff(_start, 'minutes');
};

/**
 *
 * @param order
 * @param date - SAME_DAY, NEXT_DAY, TWO_DAYS)
 */
export const computeDefaultOrderWithDefaultTimes = ({ order, date }) => {
  if (['2+_DAYS'].includes(date)) return order;
  if (!['SAME_DAY', 'NEXT_DAY'].includes(date)) return order;

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const dateString = ['SAME_DAY'].includes(date) ? today.toISOString() : tomorrow.toISOString();

  const [shipment] = order.shipments;
  return {
    ...order,
    shipments: [
      {
        ...shipment,
        dropoff_time_from: dateString,
        dropoff_time_to: dateString,
        pickup_time_from: dateString,
        pickup_time_to: dateString,
      },
    ],
  };
};
